// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2084 ? "9b0008ae" : chunkId) + "." + {"2084":"983dba6800459cce","3300":"fe23c06c28298e31","8974":"8421fbe7bbbb59a9"}[chunkId] + ".js";
};